import { Directive, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
    selector: '[appDebounceFilter]',
    standalone: false
})
export class DebounceFilterDirective implements OnInit, OnDestroy {
  @Input() appDebounceFilter = 1000; // debounce time in ms
  @Output() debounceFilterChange = new EventEmitter<string>();

  private filterSubject = new Subject<string>();
  private subscription: Subscription;
  private originalEmit: (value?: any) => void;

  constructor(private host: ComboBoxComponent) {
    const filterChange = this.host.filterChange;
    this.originalEmit = filterChange.emit;

    // Override the emit function to intercept immediate emissions
    filterChange.emit = (value: string) => {
      this.filterSubject.next(value);
    };
  }

  ngOnInit() {
    const filterChange = this.host.filterChange;

    // Convert input to number; if it is not a valid positive number (e.g. empty string ""), fall back to default
    let debounceTimeMs = Number(this.appDebounceFilter);
    if (isNaN(debounceTimeMs) || debounceTimeMs <= 0) {
      debounceTimeMs = 1000; // default debounce time in ms
    }

    // Subscribe to the debounced stream and call the original emit
    this.subscription = this.filterSubject.pipe(
      debounceTime(debounceTimeMs),
      distinctUntilChanged()
    ).subscribe((filterValue: string) => {
      this.originalEmit.call(filterChange, filterValue);
      this.debounceFilterChange.emit(filterValue);
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    // Restore the original emit function to prevent memory leaks or side effects
    if (this.host && this.host.filterChange) {
      this.host.filterChange.emit = this.originalEmit;
    }
  }
}
